import { Fragment, useState } from "react";
import Modal from "../elements/Modal";
import { lngDetect } from "../../helpers/lngDetect";
import { Link, useOutletContext } from "react-router-dom";
import ContactFormModal from "./ContactFormModal";
import Button from "../form/Button";
import { t } from "i18next";

const ContactModal = ({ isOpen, onClose = () => {}, event }) => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const { eventOrganizer: organizerData, organizer } = useOutletContext();

  // Use organizerData as primary, fallback to organizer if needed
  const currentOrganizer = organizerData || organizer;

  return (
    <Fragment>
      <Modal
        isOpen={isOpen}
        setIsOpen={onClose}
        title={`${t("Contact with")} ${
          lngDetect(event?.organizationData?.name) || "Organizer"
        }`}
        size="xl4"
        titleIcon="fa-regular fa-paper-plane"
        titleClass="!font-semibold !text-2xl !capitalize truncate max-w-[700px] w-full tracking-tight !text-deep-purple"
        headerClass="!text-black !rounded-t-2xl border-b border-surface-03 bg-primary/10 py-4 px-10"
        childrenClasses="!bg-white"
        bodyClasses={"!py-6"}
      >
        <div className="flex items-center justify-center mb-6">
          <Button
            buttonFunction={() => setIsContactModalOpen(true)}
            buttonLabel={t("Contact the event organiser")}
            buttonIcon={"fa-light fa-paper-plane"}
            buttonIconPosition="left"
          />
        </div>
        <div className="text-center text-xl md:text-2xl mb-8 text-black mt-8 font-normal capitalize">
          {t("You can contact")}{" "}
          <strong className="font-extrabold uppercase text-slate-600">
            {lngDetect(event?.organizationData?.name)}
          </strong>{" "}
          {t("through the following means")}
        </div>

        {/* <div className="flex items-center justify-center border-b border-dashed border-slate-300 mb-10">
        <Link
          to="mailto:example@example.com"
          className="flex items-center gap-2 text-purple-900 font-medium text-2xl pb-10"
        >
          <span className="w-10 h-10 rounded-full flex-shrink-0 flex items-center justify-center bg-primary/20 text-lg">
            <i className="fa-regular fa-envelope"></i>
          </span>{" "}
          Email
        </Link>
      </div> */}

        <div className="flex justify-center items-center gap-4 flex-wrap text-gray-800 text-base">
          {currentOrganizer?.data?.setting?.visibleSocialMedia &&
            currentOrganizer?.data?.setting?.socialMedia?.map((social, i) => (
              <Link
                to={social?.url || "#"}
                target="_blank"
                rel="noopener noreferrer"
                key={i}
                className="w-11 h-11 rounded-full flex-shrink-0 flex items-center justify-center text-lg text-white bg-primary-gradient"
              >
                <i className={social?.icon}></i>
              </Link>
            ))}

          {/* <Link
          to="https://facebook.com/example"
          target="_blank"
          rel="noopener noreferrer"
          className="w-11 h-11 rounded-full flex-shrink-0 flex items-center justify-center text-lg text-white bg-primary-gradient"
        >
          <i class="fa-brands fa-facebook-f"></i>
        </Link>

        <Link
          href="https://example.com"
          target="_blank"
          rel="noopener noreferrer"
          className="w-11 h-11 rounded-full flex-shrink-0 flex items-center justify-center text-lg text-white bg-primary-gradient"
        >
          <i class="fa-brands fa-x-twitter"></i>
        </Link> */}
        </div>
      </Modal>
      <ContactFormModal
        isOpen={isContactModalOpen}
        onClose={() => setIsContactModalOpen(false)}
        data={event}
        organizationData={organizerData}
      />
    </Fragment>
  );
};

export default ContactModal;
